import { createInstance } from '@datapunt/matomo-tracker-react';

const siteId = Number(import.meta.env.VITE_MATOMO_SITE_ID);
const disabled = !siteId;

export const matomoInstance = createInstance({
	urlBase: 'https://analytics.veeva.link',
	siteId: disabled ? -1 : siteId,
	disabled
});
